import * as React from "react";
import type { SVGProps } from "react";
const SvgTopRightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="top_right_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M680.576 403.84V723.2a42.667 42.667 0 1 0 85.333 0V301.227a43.093 43.093 0 0 0-43.093-43.094H300.843a42.667 42.667 0 1 0 0 85.334h319.402L268.8 694.955c-15.616 15.658-14.763 41.813 1.92 58.453 16.64 16.683 42.837 17.493 58.453 1.92l351.403-351.445z"
    />
  </svg>
);
export default SvgTopRightIcon;
